export const SAVINGS_TYPE_OPTIONS = [
  { value: "TERM", label: "Хугацаатай хадгаламж" },
  { value: "DEMAND", label: "Хугацаагүй хадгаламж" },
  { value: "CERTIFICATE", label: "Сертификат" },
];

export const SAVINGS_TYPE_LABEL = (type) => {
  const map = {
    TERM: "Хугацаатай",
    DEMAND: "Хугацаагүй",
    CERTIFICATE: "Сертификат",
  };
  return map[type] ?? type;
};

export const SAVINGS_TYPE_COLOR = (type) => {
  const map = {
    TERM: "blue",
    DEMAND: "green",
    CERTIFICATE: "gold",
  };
  return map[type] ?? "default";
};

export const CURRENCY_OPTIONS = [
  { value: "MNT", label: "MNT" },
  { value: "USD", label: "USD" },
  { value: "EUR", label: "EUR" },
  { value: "CNY", label: "CNY" },
  { value: "JPY", label: "JPY" },
];
